export default __webpack_public_path__ + "static/media/darkhole.f910cca3.png";